
let count = 0;

export const uniqueId = (prefix: string = 'id') => {
    return `${prefix}-${count++}`;
};